import { cn } from "@/lib/utils";

export interface PageSectionProps extends React.ComponentProps<"section"> {
  titulo?: React.ReactNode;
  descripcion?: React.ReactNode;
  /** Acción de la sección, alineada a la derecha del título. */
  accion?: React.ReactNode;
}

/**
 * Bloque de pantalla del Design System: tarjeta contenedora con cabecera de
 * 15px/600 y descripción de 12.5px.
 *
 * Separá los bloques de una pantalla con `gap: 18px` (usá `space-y` sólo si no
 * hay más remedio: el DS pide flex/grid + gap, no márgenes entre hermanos).
 */
export function PageSection({
  titulo,
  descripcion,
  accion,
  className,
  children,
  ...props
}: PageSectionProps) {
  return (
    <section
      className={cn("bg-card overflow-hidden rounded-2xl border", className)}
      {...props}
    >
      {(titulo || accion) && (
        <div className="border-border-subtle flex items-start gap-3 border-b px-4 py-3.5">
          <div className="min-w-0 flex-1">
            {titulo && <div className="fc-section-title">{titulo}</div>}
            {descripcion && (
              <div className="text-meta mt-0.5 text-[12.5px] leading-[1.45]">
                {descripcion}
              </div>
            )}
          </div>
          {accion && <div className="shrink-0">{accion}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
